import type { HTMLMotionProps } from "motion/react";
import { motion, useIsPresent } from "../../../lib/motion.js";

/**
 * Direct child of `AnimatePresence`. Runs the `initial`/`animate`/`exit`
 * variants and becomes inert while exiting, so a view that is animating out
 * cannot be clicked, focused or submitted a second time.
 */
export function AuthEntryPresenceView(props: HTMLMotionProps<"div">): React.JSX.Element {
  const isPresent = useIsPresent();
  return <motion.div initial="initial" animate="animate" exit="exit" {...props} inert={!isPresent} />;
}
